import "./postLoginLayout.css";

import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import React, { useMemo, useState } from "react";
import { SERVICE_CATALOG, filterCatalog, slugify } from "../../vyntezbuddy/serviceCatalog";

import SiteFooter from "../../vyntezbuddy/SiteFooter";
import SiteHeader from "../../vyntezbuddy/SiteHeader";

const PostLoginLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = sessionStorage.getItem("token");
  const user = JSON.parse(sessionStorage.getItem("vbUser") || "{}");

  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState("");

  const fullName = user?.userName || user?.fullName || user?.name || "User";
  const filteredCatalog = useMemo(() => filterCatalog(SERVICE_CATALOG, search), [search]);
  const hasProviderAccess =
    sessionStorage.getItem("vbIsProvider") === "true" || Boolean(user?.providerId) || Boolean(sessionStorage.getItem("consumerorprovideId"));

  const serviceList = useMemo(
    () =>
      filteredCatalog.flatMap((category) =>
        category.services.map((service) => ({
          category: category.category,
          service,
          path: `/services/${slugify(category.category)}?service=${slugify(service)}`
        }))
      ),
    [filteredCatalog]
  );

  const hideServicesSidebar =
    location.pathname === "/home/user-profile" ||
    location.pathname === "/home/user-addresses" ||
    location.pathname === "/home/provider-services" ||
    location.pathname === "/provider-dashboard";

  const handleMenuNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const logout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="pl-shell">
      <SiteHeader search={{ value: search, onChange: setSearch }}>
        <div className="pl-user-menu-wrap">
          <button
            type="button"
            className="pl-user-trigger"
            onClick={() => setMenuOpen((value) => !value)}
            aria-expanded={menuOpen}
            aria-label="Open user menu"
          >
            <span>{fullName.slice(0, 1).toUpperCase()}</span>
          </button>

          {menuOpen && (
            <div className="pl-user-menu">
              <p>{fullName}</p>
              <button type="button" className="pl-user-menu-item" onClick={() => handleMenuNavigate("/home/user-profile")}>
                <i className="fas fa-user" aria-hidden="true"></i>
                <span>My Profile</span>
              </button>
              <button type="button" className="pl-user-menu-item" onClick={() => handleMenuNavigate("/home/user-addresses")}>
                <i className="fas fa-location-dot" aria-hidden="true"></i>
                <span>My Addresses</span>
              </button>
              <button type="button" className="pl-user-menu-item" onClick={() => handleMenuNavigate("/home/provider-services")}>
                <i className="fas fa-sliders" aria-hidden="true"></i>
                <span>Account Settings</span>
              </button>

              <button type="button" className="pl-user-menu-item" onClick={() => handleMenuNavigate("/home/provider-services")}>
                <i className="fas fa-user-plus" aria-hidden="true"></i>
                <span>{hasProviderAccess ? "Manage Provider" : "Become Provider"}</span>
              </button>

              <div className="pl-user-menu-divider" />

              <button type="button" className="pl-user-menu-item pl-user-menu-item--logout" onClick={logout}>
                <i className="fas fa-right-from-bracket" aria-hidden="true"></i>
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </SiteHeader>

      <div className={`pl-shell-body ${hideServicesSidebar ? "pl-shell-body--single-column" : ""}`}>
        {!hideServicesSidebar && (
          <aside className="pl-sidebar" aria-label="Services sidebar">
            <div className="pl-sidebar-head">
              <h3>Services</h3>
              <span>{serviceList.length} available</span>
            </div>

            <div className="pl-sidebar-list">
              {serviceList.map((item) => (
                <button
                  type="button"
                  key={`${item.category}-${item.service}`}
                  className="pl-service-link"
                  onClick={() => navigate(item.path)}
                  title={`${item.category} - ${item.service}`}
                >
                  <small>{item.category}</small>
                  <strong>{item.service}</strong>
                </button>
              ))}

              {!serviceList.length && <p className="pl-empty">No services match your search.</p>}
            </div>
          </aside>
        )}

        <section className="pl-content">
          <Outlet />
        </section>
      </div>

      <SiteFooter />
    </div>
  );
};

export default PostLoginLayout;
